import React from "react";
import {ArticlePage} from "./articles_components";
import { createRoot } from 'react-dom/client';


const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<ArticlePage />);
